module.exports = __webpack_public_path__ + "static/air-ambulance-bc60cb67d5e693f8910f2e5d0ce25f5d.jpg";